// extracted by mini-css-extract-plugin
export var navigation = "navigation-module--navigation--kqix2";
export var navigationItem = "navigation-module--navigationItem--0+3fY";